import { Text } from '@oneaudi/unified-web-components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Context } from '../../../context/Context';

const HeadlineWrapper = styled.div`
  text-align: center;
  margin-block: var(--spacing-relative-md);
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    text-align: left;
    margin-top: 0;
  }
`;

const VtpHeadline = () => {
  const {
    vtpData: { vtpLabel },
  } = useContext(Context);

  return (
    <HeadlineWrapper>
      <Text tag="span" variant={{ type: 'copy', order: '2', style: 'normal' }}>
        {vtpLabel}
      </Text>
    </HeadlineWrapper>
  );
};

export default VtpHeadline;
